import OauthManager from "./OauthManager";

import ep from "./EpConst";
class OauthKit {
  /**
   *
   * @param {object} store vuex project store
   * @param {object} config auth_service_config
   */
  constructor(store, config) {
    this.store = store;
    this.om = new OauthManager(config);
  }
  showSignup() {
    this.showMyGamesSignin();
  }
  showLogin() {
    this.showMyGamesLogin();
  }
  setStore(store) {
    this.store = store;
  }
  showProjectRegister() {
    if (!this.store) {
      throw new Error("we need store");
    }
    this.store.commit("global/showReg");
  }
  /**
   * just proxy to __GEM
   */
  detectAndDownload() {
    window.__GEM.detectAndDownload();
  }
  showVkSignin() {
    this.om.showWindow(false, ep.EP_VK);
  }
  showOkAuth() {
    this.om.showWindow(false, ep.EP_OK);
  }
  showMailRuSignin() {
    this.om.showWindow(false, ep.EP_MAILRU);
  }
  showSteamSignin() {
    this.om.showWindow(false, ep.EP_STEAM);
  }
  showEgSignin() {
    this.om.showWindow(false, ep.EP_EPICGAMES);
  }
  showPsSignin() {
    this.om.showWindow(false, ep.EP_PLAYSTATION);
  }
  showXboxSignin() {
    this.om.showWindow(false, ep.EP_XBOX);
  }

  showFbSignin() {
    this.om.showWindow(false, ep.EP_FB);
  }
  showGoogleSignin() {
    this.om.showWindow(false, ep.EP_GOOGLE);
  }
  showTwitchSignin() {
    this.om.showWindow(false, ep.EP_TWITCH);
  }
  showTwitterSignin() {
    this.om.showWindow(false, ep.EP_TWITTER);
  }
  showMyGamesSignin() {
    this.om.showWindow();
  }
  showMyGamesLogin() {
    this.om.showWindow();
  }
  getGcRedirectUrl(host = null) {
    let destination_url = window.location.href;
    if (host) {
      destination_url = host + window.location.pathname + window.location.search;
    }
    return this.om.getOauthUrl(false, null, 1, destination_url, host);
  }
}
export default OauthKit;
